import React, { Fragment, useEffect, useState } from 'react';
import { Button, Box } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { useComplete } from './hooks/use-complete';
import { enableSpinner, disableSpinner } from '../mle/mle-actions';
import { FORCE_COMPLETION_SPINNER } from '../../helpers/constants';

export const ForceComplete = () => {
  const { mutate: complete, isSuccess, isLoading } = useComplete();
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (window._env_.FeatureToggle && JSON.parse(window._env_.FeatureToggle).forceComplete) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, []);

  useEffect(() => {
    if (isSuccess) {
      window.history.back();
    }
    dispatch(disableSpinner(FORCE_COMPLETION_SPINNER));
  }, [isSuccess]);

  useEffect(() => {
    if (isLoading) {
      dispatch(enableSpinner(FORCE_COMPLETION_SPINNER));
    }
  }, [isLoading]);

  return (
    <Fragment>
      {
        show && (
          <Box>
            <Button
              colorScheme="red"
              onClick={complete}
            >
              Force complete
            </Button>
          </Box>
        )
      }
    </Fragment>
  );
};
